<template>
  <div id="container">
    <div v-if="dataReady">
      <!-- <VueQRCodeComponent text="aroncarter"></VueQRCodeComponent> -->

      <div v-if="showMain">
        <vs-row vs-w="12" vs-type="flex" vs-justify="center">
          <vs-col vs-lg="12" vs-sm="12" vs-xs="12" vs-type="flex" vs-justify="center" vs-align="center">
            <h2>Monthly Movement</h2>
          </vs-col>
        </vs-row>
        <vs-row vs-w="12" vs-type="flex" vs-justify="center" class="pb-5">
          <vs-col vs-lg="12" vs-sm="12" vs-xs="12" vs-type="flex" vs-justify="center" vs-align="center">
            <h3 class="text-primary">{{ currentMonth }}</h3>
          </vs-col>
        </vs-row>
        <vs-row vs-w="12" vs-type="flex" vs-justify="center" class="pb-5">
          <vs-col vs-lg="12" vs-sm="12" vs-xs="12" vs-type="flex" vs-justify="center" vs-align="center">

            <datepicker format="yyyy-MM-dd" placeholder="Date From" v-model="dateFrom"></datepicker>&nbsp;&nbsp;
            <datepicker format="yyyy-MM-dd" placeholder="Date To" v-model="dateTo"></datepicker>
            &nbsp; &nbsp;
            <vs-button color="primary" @click="getData()">Filter</vs-button>
            &nbsp; &nbsp;
            <vs-button color="gray" @click="dateFrom = ''; dateTo = ''; getData()">Clear</vs-button>
          </vs-col>
        </vs-row>
        <vs-row vs-w="12" vs-type="flex" vs-justify="center">
          <vs-col vs-lg="6" vs-sm="6" vs-xs="12" vs-type="flex" vs-justify="center" vs-align="center">
            <vx-card>
              <resb :key="resbTotal" @showData="(data) => showData(data)" :resbData="resbData" :resbgsCount="resbgsCount"
                :resbgrCount="resbgrCount" :resbTotal="resbTotal">
              </resb>
            </vx-card> &nbsp;
          </vs-col>

          <vs-col vs-lg="6" vs-sm="6" vs-xs="12" vs-type="flex" vs-justify="center" vs-align="center">
            &nbsp; <vx-card>
              <reem :key="reemTotal" @showData="(data) => showData(data)" :reemData="reemData" :reemgsCount="reemgsCount"
                :reemgrCount="reemgrCount" :reemTotal="reemTotal">
              </reem>
            </vx-card>
          </vs-col>
        </vs-row>
      </div>


      <div v-else>
        <!-- SUB: {{ subject }} -->
        <showDetails :dateFrom="dateFrom" :dateTo="dateTo" @resetMe="(data) => showData(data)" :key="subject"
          v-if="checkifSubjectContainResb()" :subject="subject" :resbData="resbData" :resbgsCount="resbgsCount"
          :resbgrCount="resbgrCount" :resbTotal="resbTotal" @close="showMain = true">
        </showDetails>

        <showDetails :dateFrom="dateFrom" :dateTo="dateTo" @resetMe="(data) => showData(data)" :key="subject + 1" v-else
          :subject="subject" :resbData="reemData" :resbgsCount="reemgsCount" :resbgrCount="reemgrCount"
          :resbTotal="reemTotal" @close="showMain = true">
        </showDetails>
      </div>
    </div>
  </div>
</template>
<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import { axiosMixin } from '../../mixin/axiosMixin';
import donutHandler from './donutHandler.vue'
import resb from './resb.vue';
import reem from './reem.vue';
import showDetails from './showDetails.vue'
import aronDate from "@/components/aron/formElements/customDate";
import Datepicker from 'vuejs-datepicker';
import VueQRCodeComponent from 'vue-qrcode-component'
// import QrcodeVue from 'qrcode.vue'
export default {
  mixins: [axiosMixin],
  components: {
    StatisticsCardLine,
    donutHandler,
    resb,
    reem,
    showDetails,
    VueQRCodeComponent,
    aronDate,
    Datepicker
  },

  data() {
    return {
      resbData: {},
      reemData: {},
      resbgrCount: 0,
      resbgsCount: 0,
      resbTotal: 0,
      reemgrCount: 0,
      reemgsCount: 0,
      reemTotal: 0,
      dataReady: false,
      showMain: true,
      currentMonth: '',
      subject: '',
      structureDateFrom: {
        value: ''
      },
      dateFrom: '',
      structureDateTo: {
        value: ''
      },
      dateTo: '',

    }
  },
  methods: {
    checkifSubjectContainResb() {
      //check if subject is contain the word resb
      var char = "resb";
      if (this.subject.toLowerCase().includes(char.toLowerCase())) {
        return true;
      }
      return false;
    },
    showData(subject) {
      console.log("subject:", subject)
      this.subject = subject;
      this.showMain = false;
    },
    startLoading() {
      this.$vs.loading({
        container: '#container',
        scale: 0.6
      });
    },
    stopLoading() {
      this.$vs.loading.close('#container > .con-vs-loading');
    },
    extractDateFromObject(dateObject) {
      if (dateObject instanceof Date) {
        const dateString = dateObject.toISOString();
        return dateString.substring(0, 10);
      } else {
        console.log("Invalid date object");
        // Handle the error or set a default value
        return null; // or any other default value
      }
    },
    getData() {
      this.startLoading();

      this.aronPost('getStockMovementChart', { dateFrom: this.extractDateFromObject(this.dateFrom), dateTo: this.extractDateFromObject(this.dateTo) }, '', '')
        .then(response => {
          if (response.status) {
            this.resbData = response.data.resbData;
            this.reemData = response.data.reemData;
            this.resbgrCount = response.data.resbgrCount;
            this.resbgsCount = response.data.resbgsCount;
            this.resbTotal = response.data.resbTotal;
            this.reemgrCount = response.data.reemgrCount;
            this.reemgsCount = response.data.reemgsCount;
            this.reemTotal = response.data.reemTotal;


          } else {
            this.errorAlert('Error', response.data.error)
          }
          this.dataReady = true;
          this.stopLoading();
        })
        .catch(error => {
          console.log('error:', error);
          this.stopLoading();
        })
    },
    getCurrentMonth() {
      // Create a new Date object
      var currentDate = new Date();

      // Get the current month (returns a zero-based index)
      var month = currentDate.getMonth();

      // Define an array of month names
      var monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];

      // Get the current year
      var year = currentDate.getFullYear();

      // Create the desired date format
      this.currentMonth = monthNames[month] + " " + year;
    }

  },
  mounted() {
    this.dataReady = false;
    this.getData();
    this.getCurrentMonth();
  },
  created() {

  }
};
</script>
<style scoped>
.donutTitle {
  font-size: 18px;
  font-weight: bold;
  color: white;
}

.companyTitle {
  font-size: 30px;
  font-weight: bold;
  color: white;
  padding: 10px;
}

.stockTitle {
  font-size: 28px;
  font-weight: bold;
  color: white;
}
</style>


